import { memo, useState, useEffect, useContext } from 'react';
import Page from "../Page";
import { useAccess } from "src/hooks/useAccess.hook";
import { Card, Stack } from "@mui/material";
import { BaseTable } from "../BaseTable/BaseTable";
import { useList } from "src/hooks/useFetch.hook";
import { roleListColumns } from "./roles.constants";
import { FEATURE } from "src/util/enums";
import { useNavigate, useParams } from "react-router-dom";
import { CommonSearchbar } from "src/layouts/dashboard/Searchbar";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { yearFirstDateTimeFormatInTimezone } from "src/utils/timezoneFormat";
import ExportCSV from "src/components/ExportCsv/ExportCSV";
import { Context } from "src/context";

export const RoleList = () => {
  const navigate = useNavigate()
  const { teamId } = useParams();
  const hasCreateAccess = useAccess(FEATURE.ROLES, "C");
  const isReadOnly = useAccess(FEATURE.ROLES, "R");
  const { timezone } = useContext(Context);
  const { data: roles = [], isFetching } = useList("roles", teamId);
  const [tableData, setTableData] = useState();
  const rowOrCellClickRedirect = ({ id }) => {
    // if (isReadOnly) return;
    navigate(`/roles/${id}`);
  };

  useEffect(() => {
    if (!isFetching) {
      let data = [...roles];
      setTableData(data);
    }
  }, [isFetching]);

  const handleSearching = (event) => {
    const dataToSearchFrom = roles;
    const searchValue = event.target.value.trim().toString().toLowerCase();
    if (searchValue) {
      const filteredDataArr = dataToSearchFrom.reduce(
        (filteredDataArr, currentObj) => {
          const relevantFields = [
            "roleName",
            "createTime",
          ];
          const allValuesArr = Object.entries(currentObj)
            .filter(([key, value]) => relevantFields.includes(key))
            .map(([key, value]) =>
              key === "createdAt"
                ? (timezone.timezone?.value
                    ? yearFirstDateTimeFormatInTimezone(value, timezone.timezone.value)
                    : yearFirstDateTimeFormat(value)
                  ).toString()
                : value ? value.toString().toLowerCase() : ""
            );
          const searchResult = allValuesArr.find((value) =>
            value.includes(searchValue)
          );
          if (searchResult) {
            filteredDataArr = [...filteredDataArr, currentObj];
          }
          return filteredDataArr;
        },
        []
      );
      setTableData(filteredDataArr);
    } else setTableData([...roles]);
  };

  return (
    <Page
      title="Roles | Smart-CMS"
      actions={
        hasCreateAccess
          ? [{ path: "/roles/new", text: "Add Role", icon: "eva:plus-fill" }]
          : []
      }
      hasCreateAccess={hasCreateAccess}
    >
      <Card sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <CommonSearchbar
            placeholder="Search"
            searchFunc={(e) => handleSearching(e)}
          />
          <ExportCSV
            rows={tableData || []}
            columns={roleListColumns(isReadOnly, timezone.timezone?.value)}
            csvMorphemes="roles"
            csvColumns={roleListColumns(isReadOnly, timezone.timezone?.value)}
            timeZone={timezone.timezone?.value}
          />
        </Stack>
        <BaseTable
          rows={tableData ?? []}
          columns={roleListColumns(isReadOnly, timezone.timezone?.value)}
          loading={isFetching}
          getRowId={(row) => row.roleId}
          rowOrCellClickRedirect={rowOrCellClickRedirect}
          isReadOnly={isReadOnly}
          showExportCsvBtn={false}
          csvMorphemes="roles"
          csvColumns={roleListColumns(isReadOnly, timezone.timezone?.value)}
        />
      </Card>
    </Page>
  );
};